import React from 'react';
import {
    Box,
    LinearProgress,
    Typography,
    Paper,
    useTheme
} from '@mui/material';
import { tokens } from '../../../../theme';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';

const ReviewProgressBar = ({ progress }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Paper 
            elevation={2}
            sx={{ 
                p: 2,
                mb: 2
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Box display="flex" alignItems="center" gap={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <CheckCircleIcon color="success" fontSize="small" />
                        <Typography variant="body2">
                            <strong>Reviewed:</strong> {progress.reviewed}
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <PendingIcon color="warning" fontSize="small" />
                        <Typography variant="body2">
                            <strong>Remaining:</strong> {progress.total - progress.reviewed}
                        </Typography>
                    </Box>
                    <Typography variant="body2">
                        <strong>Total:</strong> {progress.total}
                    </Typography>
                </Box>
                <Typography variant="h6" color={colors.greenAccent[400]}>
                    {progress.percentage}% Complete
                </Typography>
            </Box>
            
            <LinearProgress
                variant="determinate"
                value={progress.percentage}
                sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: colors.grey[800],
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: 
                            progress.percentage === 100 ? colors.greenAccent[500] :
                            progress.percentage >= 50 ? colors.blueAccent[500] :
                            colors.yellowAccent[600]
                    }
                }}
            />
        </Paper>
    );
};

export default ReviewProgressBar;